module.exports = __webpack_public_path__ + "static/process_img_card1-53cd19268c589a604163e720cd387b4d.png";